import React from 'react';
import './Card.css';

export interface CardProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, children, className = '' }) => {
  return (
    <div className={`card ${className}`}>
      {title && <h2 className="form-title">{title}</h2>}
      {children}
    </div>
  );
};

export default Card; 